import { Category, Product, ProductSpoilageReason } from "../../models/Product";

export const REQUEST_PRODUCTSV2 = "REQUEST_PRODUCTSV2";
export const REQUEST_SPOILAGE_REASONS = "REQUEST_SPOILAGE_REASONS";
export const REQUEST_PRODUCT_CATEGORIES = "REQUEST_PRODUCT_CATEGORIES";

export interface FetchProductsV2 {
  type: typeof REQUEST_PRODUCTSV2;
  payload: ReadonlyArray<Product>;
}

export interface FetchSpoilageReasons {
  type: typeof REQUEST_SPOILAGE_REASONS;
  payload: ReadonlyArray<ProductSpoilageReason>;
}

export interface FetchProductCategories {
  type: typeof REQUEST_PRODUCT_CATEGORIES;
  payload: Category[];
}

export interface ProductState {
  isLoading: boolean;
  products: ReadonlyArray<Product>;
}
export interface ProductsState {
  productState: ProductState;
  categories: ReadonlyArray<Category>;
  spoilageReasons: ReadonlyArray<ProductSpoilageReason>;
}

export type ProductActionTypes =
  | FetchProductsV2
  | FetchSpoilageReasons
  | FetchProductCategories;
